import { Button, Col, Container } from '@microfrontends/react-components'
import { useRouter } from 'next/router'
import { useContext } from 'react'
import RulingNumberSliderV2 from '../../../components/Numerology/RulingNumberSliderV2'
import GoToNumerology from '../../../components/NumerologyV2/GoToNumerology'
import AppContext from '../../../context/AppContext'
import { EDevice } from '../../MainLayout'
import { Box } from '../../NumerologyContainerV2/Numerology.css'
import { SlideRulingNumberCss, SliderWrapCss } from '../RulingNumberDetail.css'
interface IProps {
	handleOpen: () => void
}
export default function SlideRulingNumber({ handleOpen }: IProps) {
	const { breakpoint, t } = useContext(AppContext)
	const router = useRouter()
	const { rulingNumberId } = router.query
	return (
		<SlideRulingNumberCss>
			<Container>
				<SliderWrapCss align='middle' justify='center'>
					<GoToNumerology />
					<Col sm={22} xs={24}>
						<RulingNumberSliderV2
							rulingNumber={rulingNumberId as string}
						/>
					</Col>
					{breakpoint !== EDevice.MOBILE ? (
						<Box className='center'>
							<Button
								type='primary'
								className='search_button'
								onClick={handleOpen}
							>
								{t('Tra cứu nhân số học')}
							</Button>
						</Box>
					) : null}
				</SliderWrapCss>
			</Container>
		</SlideRulingNumberCss>
	)
}
